import { ElementType, Template } from "@/types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const KlosLabelPopup: Template = {
  id: "klos-label",
  name: "Klos Label",
  industry: "template3",
  elements: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px 20px",
        textAlign: "center",
        maxWidth: "992px",
        width: "auto",
        height: "auto",
        borderRadius: "0px",
        border: "none",
        backgroundColor: "transparent",
      },
      children: [
        {
          id: generateId(),
          type: "image",
          src: "/public//template3/popupKlos.png",
          alt: "Klos Label",
          styles: {
            width: "100%",
            height: "auto",
            objectFit: "contain",
            margin: "0px 0px 0px 0px",
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            position: "absolute",
            top: "0",
            right: "0",
            width: "40px",
            height: "40px",
            minWidth: "40px",
            minHeight: "40px",
            borderRadius: "100%",
            backgroundColor: "#ffffffa0",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/public/template3/closePopup.png",
              alt: "close",
              styles: {
                width: "100%",
                height: "100%",
                objectFit: "contain",
                cursor: "pointer",
              },
            },
          ],
        },
      ],
    },
  ],
};
